<template>
  <div class="outer-wrapper">
<van-loading type="spinner" color="#1989fa" />
    
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "taskDo",
  props:{
    enid:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    this.judge();
  },
  methods: {
    judge() {
      this.$axios
        .post(this.$url + "/inspection_do", {
          userToken: userToken,
          ask_data: "taskScanJudge",
          enid:this.enid
        })
        .then(response => {
          if(response.data.stat==='ok'){
            if(response.data.res_record==='start'){
              window.location.href = '/taskStart/' + this.enid;
            }else if(response.data.res_record==='end'){
              window.location.href = '/taskEnd/' + this.enid;
            }else if(response.data.res_record==='allot'){
              window.location.href = '/taskAllot/' + this.enid;
            }else if(response.data.res_record==='accept'){
              window.location.href = '/taskAccept/' + this.enid;
            }else{
              window.location.href = '/taskInfo/' + this.enid;
            }
          }else{
            this.$toast.fail('网络连接有误！');
          }
        });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
  text-align: center;
  width:100%;
  top:40%;
  position: fixed;
}
</style>